import { render, staticRenderFns } from "./SwiperList.vue?vue&type=template&id=2872026a&scoped=true"
import script from "./SwiperList.vue?vue&type=script&lang=js"
export * from "./SwiperList.vue?vue&type=script&lang=js"
import style0 from "./SwiperList.vue?vue&type=style&index=0&id=2872026a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2872026a",
  null
  
)

export default component.exports